//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import React, { useCallback, useMemo, useState } from 'react';
import {
  TargetSelectorContext, type TargetSelectorRegistration
} from './TargetSelectorContext';

/**
 * Holds whichever page is currently lending the header's dataset selector its
 * own entries.  Sits above the header so a page below it can contribute, and
 * empties when that page unmounts — which is what keeps a draft graph out of
 * the selector everywhere else.
 */
const TargetSelectorProvider = ({
  children
}: { children: React.ReactNode }) => {
  const [registration, setRegistration] =
    useState<TargetSelectorRegistration | null>(null);

  const register = useCallback(
    (next: TargetSelectorRegistration | null) => setRegistration(next), []);

  const value = useMemo(
    () => ({ registration, register }), [registration, register]);

  return (
    <TargetSelectorContext.Provider value={value}>
      {children}
    </TargetSelectorContext.Provider>
  );
};

export default TargetSelectorProvider;
